'use strict';

(function () {
    Fotobook.rectsIntersect = {
        /**
         * Возвращает номера пересеченных сторон (0-не пересекает)
         *
         * @param safeAreaCords
         * @param containerCords
         * @returns {number[]}
         */
        getCrossedBorders(safeAreaCords, containerCords) {
            //округлить значения до целых во избежание погрешности расчетов
            const sides = [0, 0, 0, 0]; // 1-верхняя ... 4-левая
            if (Math.round(containerCords.top) < Math.round(safeAreaCords.top)) {
                sides[0] = 1;
            }
            if (Math.round(containerCords.right) > Math.round(safeAreaCords.right)) {
                sides[1] = 1;
            }
            if (Math.round(containerCords.bottom) > Math.round(safeAreaCords.bottom)) {
                sides[2] = 1;
            }
            if (Math.round(containerCords.left) < Math.round(safeAreaCords.left)) {
                sides[3] = 1;
            }

            return sides;
        },

        intersected(safeAreaCords, containerCords) {
            if (
                Math.round(safeAreaCords.left) > (Math.round(containerCords.left) + Math.round(containerCords.width)) ||
                (Math.round(safeAreaCords.left) + Math.round(safeAreaCords.width)) < Math.round(containerCords.left)) {
                return false;
            }
            if (
                Math.round(safeAreaCords.top) > (Math.round(containerCords.top) + Math.round(containerCords.height)) ||
            (Math.round(safeAreaCords.top) + Math.round(safeAreaCords.height)) < Math.round(safeAreaCords.top)) {
                return false;
            }

            return true;
        },

        /**
         * Пересечение отрезков на плоскости
         * Параметрами предаются отрезки с координатами начала и конца [x1, y1, x2, y2]
         *
         * @link https://acmp.ru/article.asp?id_text=170
         * @param segment1 array отрезок 1
         * @param segment2 array отрезок 2
         * @returns {boolean}
         */
        intersectedSegments(segment1, segment2) {
            const s1 = segment1.map((x) => Math.round(x));
            const s2 = segment2.map((x) => Math.round(x));
            const r1 = (s2[2] - s2[0]) * (s1[1] - s2[1]) - (s2[3] - s2[1]) * (s1[0] - s2[0]);
            const r2 = (s2[2] - s2[0]) * (s1[3] - s2[1]) - (s2[3] - s2[1]) * (s1[2] - s2[0]);
            const r3 = (s1[2] - s1[0]) * (s2[1] - s1[1]) - (s1[3] - s1[1]) * (s2[0] - s1[0]);
            const r4 = (s1[2] - s1[0]) * (s2[3] - s1[1]) - (s1[3] - s1[1]) * (s2[2] - s1[0]);

            return (r1 * r2 < 0) && (r3 * r4 < 0);
        },
    };
})();
